<script setup>
// import { ref } from 'vue';
import StockTable from "./Tables/StockTable.vue";
// import SawitBuahScheduleTable from "./Tables/SawitBuahScheduleTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
import CustomComboBox from "@/components/Custom_DDL_Checkbox.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Stock</h6>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Item</label>
                            <!-- <select class="form-control" v-model="model.stock.id"> 
                                <optgroup v-for="(items, category) in groupedStockItems" :label="category" :key="category" > 
                                    <option v-for="(itemObj) in items" :key="itemObj.id" :value="itemObj.id" > 
                                        {{ itemObj.item }} - {{ itemObj.supplier }}
                                    </option> 
                                </optgroup> 
                            </select> -->
                            <select class="form-control" v-model="model.stock.id" @change="loadCapacityPrice()">
                                <optgroup
                                    v-for="(items, groupLabel) in groupedStockItems"
                                    :key="groupLabel"
                                    :label="groupLabel"
                                >
                                    <option
                                    v-for="item in items"
                                    :key="item.id"
                                    :value="item.id"
                                    
                                    >
                                    {{ item.item }}
                                    </option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Quantity (Beg/Tong)</label>
                            <input class="form-control" v-model="model.stock.quantity" id="input_quantity" type="number" placeholder="1" />
                        </div>
                        <!-- <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Quantity (Biji)</label>
                            <input class="form-control" v-model="model.sawitbuah.quantity" id="input_quantity" type="number" placeholder="200" />
                        </div> -->
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Capacity per quantity(L/KG only)</label>
                            <input class="form-control" v-model="model.stock.capacity" id="input_capacity" type="text" placeholder="4L" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">User</label>
                            <argon-input type="text" v-model="model.stock.usedby" id="input_usedby" placeholder="Zin Aun" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input type="date" id="input_dateto" class="form-control" v-model="model.stock.date">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Status</label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="inStock" name="stock-status" class="me-3" :checked="model.stock.status === 0" @click="model.stock.status = 0">In</argon-radio>
                                <argon-radio class="me-3" id="outStock" name="stock-status" :checked="model.stock.status === 1" @click="model.stock.status = 1">Out</argon-radio>
                                <argon-radio id="inoutStock" name="stock-status" :checked="model.stock.status === 2" @click="model.stock.status = 2">In & Out</argon-radio>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.stock.remark"  placeholder="Remark...." />
                        </div>
                        <div class="col-md-3" v-show="model.stock.status === 0 || model.stock.status === 2">
                            <label for="example-text-input" class="form-control-label">Unit Price (RM)</label>
                            <argon-input type="number" id="input_price" v-model="model.stock.price"  placeholder="Price...." />
                        </div>
                        <div class="col-md-3" v-show="model.stock.status === 1 || model.stock.status === 2 ">
                            <label for="example-text-input" class="form-control-label" >Guna Di <font-awesome-icon :icon="['fas', 'circle-info']"   /></label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="Nursery" name="stock-usedat" class="me-3" :checked="model.stock.usedat === 0" @change="updateLocationList(0)">Nursery</argon-radio>
                                <argon-radio id="Outside" name="stock-usedat" :checked="model.stock.usedat === 1" @change="updateLocationList(1)" >Outside</argon-radio>
                            </div>
                            <!-- <select class="form-control" v-model="model.stock.status">
                                <option value="0">In</option>
                                <option value="1">Out</option>
                            </select> -->
                        </div>
                        <div class="col-md-3" v-show="model.stock.status === 1 || model.stock.status === 2">
                            <label for="example-text-input" class="form-control-label">Location</label>
                            <CustomComboBox :list="locationlist" v-model="model.stock.location"/>
                            <!-- <argon-input type="text" id="input_location" v-model="model.stock.location"  placeholder="Location...." /> -->
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-10">
                            <button class="btn btn-info " @click="addStock" style="float: right;" id="btn_camera">Open Camera</button>
                        </div> -->
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addStock" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-md-12">
            <StockTable :key="componentKey" />
        </div>
    </div>
    <!-- <div class="mt-4 row">
        <div class="col-md-6">
            <SawitBuahScheduleTable :key="sawitBuahScheduleKey" />
        </div>
    </div> -->
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'stockCreate',
  data(){
    return {
        // image:'',
        componentKey: 0,
        // sawitBuahScheduleKey: 0,
    //   errorList: '',
      model:{
        stock:{
            id:'',
            item:'',
            status:0,
            quantity:'',
            capacity:'',
            usedby:'',
            remark:'',
            location:'',
            date: new Date().toISOString().slice(0,10),
            usedat:0,
            price:'0'
        },
        locationlist:[],
        stockItem:[]
      },
      rawDate:'',
    }
  },
  computed: { 
    groupedStockItems() { 
        const groups = {};

        this.model.stockItem.forEach(item => {
        const groupKey = `${item.category} / ${item.supplier}`;
        if (!groups[groupKey]) {
            groups[groupKey] = [];
        }
        groups[groupKey].push(item);
        });

        return groups;
    } 
  },
  mounted(){
    this.listAllStockProfile();
    this.updateLocationList(this.model.stock.usedat);
  },
  methods: {
    loadCapacityPrice(){
        axios.get('stock/getStockProfileById/'+this.model.stock.id)
                .then(res => {
                    this.model.stock.price = res.data.stockprofileid[0].price;
                    this.model.stock.capacity = res.data.stockprofileid[0].capacity;
               
                }).catch(function (error){
                    
                    console.log('Error',error.message);
                });
    },
    updateLocationList(usedat){
        if (this.model.stock.usedat === usedat) return; // no change
        this.model.stock.usedat = usedat;
        this.locationlist = [];
        this.model.stock.location = '';
        if(this.model.stock.usedat == "0"){
            axios.get('nursery/listAllNurseryBatchActiveStatus')
                .then(res => {
                console.log(res.data.nurseryBatchList,"Success");
                res.data.nurseryBatchList.forEach(element => {
                    var batchObj = {
                        "text": element.batchno, "value":element.batchno
                    }
                    this.locationlist.push(batchObj);
                });
                }).catch(function (error){
                    
                    console.log('Error',error.message);
                });
        }else{
            axios.get('block/getBlockidList')
                .then(res => {
                console.log(res.data.blockidList,"Success");
                res.data.blockidList.forEach(element => {
                    var blockObj = {
                        "text": element.blockid, "value":element.blockname
                    }
                    this.locationlist.push(blockObj);
                    
                });
                }).catch(function (error){
                    
                    console.log('Error',error.message);
                });
        }
    },
    addStock(){
        const found = this.model.stockItem.find(obj => Object.values(obj)[0] === this.model.stock.id);
        this.model.stock.item = found.item;
        //var mythis = this;
        //console.log(JSON.stringify(this.model.stock));
        axios.post('stock/addStock',this.model.stock)
            .then(res => {
                alert(res.data.message);
                // this.uploadImage();
                this.model.stock = {
                    id: this.model.stockItem[0].id,
                    item:'',
                    status:0,
                    quantity:'',
                    capacity:'',
                    usedby:'',
                    remark:'',
                    location:'',
                    usedat:0,
                    date:new Date().toISOString().slice(0,10),
                    price:'0'
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Item, quantity and status is required!');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    listAllStockProfile(){
        axios.get('stock/listAllStockProfile')
            .then(res => {
                this.model.stockItem = res.data.stockprofile;
                this.model.stock.id = res.data.stockprofile[0].id;
                this.model.stock.price = res.data.stockprofile[0].price;
                this.model.stock.capacity = res.data.stockprofile[0].capacity;
                if(this.$route.params.id != ''){
                    this.model.stock.id = this.$route.params.id;
                    this.model.stock.status = this.$route.params.status;
                    //console.log(this.$route.params.status,"status");
                }
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
    
  },
}
</script>